import React from "react";

function OPStackDev() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer for OP Stack Development?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  At Xeer Technology, we specialize in leveraging OP Stack’s
                  robust tools to create efficient, Ethereum-compatible
                  solutions. Our team brings extensive experience in modular
                  development and Ethereum scaling to help your project excel in
                  performance, security, and scalability.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default OPStackDev;
